import { Table, TableCell, TableRow } from "../../../design/table";
import { Link } from "../../../design/link";
import { Holiday } from "../../../models/Holiday";
import moment from "moment";
import HolidayButton from "../../../components/HolidayButton";

const HolidayListItem: React.FC<{
  holiday: Holiday;
  years: number[];
}> = ({ holiday, years }) => {
  const getHolidayDateForYear = (holidayDates: string[], year: number) => {
    return holidayDates.find((d) => moment(d).year() === year) || null;
  };

  return (
    <TableRow key={holiday._id}>
      <TableCell className="font-medium">{holiday.name}</TableCell>
      {years.map((year) => {
        const date = getHolidayDateForYear(holiday.dates || [], year);
        return (
          <TableCell key={year} className="text-center">
            {date ? moment(date).format("MMM D") : "—"}
          </TableCell>
        );
      })}
      <TableCell className="text-center">
        <HolidayButton
          holiday={holiday}
          holidayId={holiday._id}
          className="text-blue-500 hover:underline"
        >
          Edit
        </HolidayButton>
      </TableCell>
    </TableRow>
  );
};
export default HolidayListItem;
